import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryV1 } from './baseQueryV1';

export const designationApi = createApi({
  reducerPath: 'designationApi',
  baseQuery: baseQueryV1,
  endpoints: (builder) => ({
    getDesignations: builder.query({
      query: (params) => ({
        url: 'designation',
        method: 'GET',
        params,
      }),
      transformResponse: (res) => res?.data,
    }),
    getDesignationsByDepartment: builder.query({
      query: (id) => ({
        url: `designation/department/${id}`,
        method: 'GET',
      }),
      transformResponse: (res) => res?.data,
    }),

    addDesignation: builder.mutation({
      query: (payload) => ({
        url: 'designation',
        method: 'POST',
        body: payload,
      }),
      transformResponse: (res) => res?.data,
    }),

    updateDesignation: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `designation/${id}`,
        method: 'PUT',
        body: payload,
      }),
      transformResponse: (res) => res?.data,
    }),

    deleteDesignation: builder.mutation({
      query: (id) => ({
        url: `designation/${id}`,
        method: 'DELETE',
      }),
      transformResponse: (res) => res?.data,
    }),
  }),
});

export const {
  useGetDesignationsQuery,
  useAddDesignationMutation,
  useUpdateDesignationMutation,
  useDeleteDesignationMutation,
  useGetDesignationsByDepartmentQuery,
} = designationApi;
